






























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: 'AppSwitcherEntry',
    components: {},
})
export default class AppSwitcherEntry extends Vue {
    @Prop({ type: String, required: true }) private icon!: string;
    @Prop({ type: String, required: true }) private translationKey!: string;
    @Prop({ type: [String, Function], required: true }) private url!: string | (() => string);
    @Prop({ type: Boolean, default: false }) private isAlreadyLoading?: boolean;

    private loading: boolean = false;
    private timeoutInMs: number = 3000;

    private openApp() {
        if (this.isAlreadyLoading) {
            // TODO: handle already loading state
            return;
        }

        this.loading = true;
        this.$emit('loading', true);

        if (this.url) {
            location.href = typeof this.url === 'function' ? this.url() : this.url;
        }

        setTimeout(() => {
            this.loading = false;
            this.$emit('loading', false);

            // TODO: handle error state
        }, this.timeoutInMs);
    }
}
